const ThisMatters = () => (
    <section id="this-matters" className="gg-bg-solid-green-light">
        <div className="container-fluid py-5">
            <div className="row justify-content-center align-items-center mb-5 text-center">
                <h2 className="col-11 fw-bold">Here’s Why This Matters For You</h2>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-4 col-11 text-wrap text-break">
                    <p className="mb-3">
                        GlucoGen 17 was <b>never designed to be a quick fix.</b><br />
                        <b>It’s a metabolic reset.</b> A deep, cellular shift in how your body handles sugar.
                    </p>
                    <p className="fw-bold mb-4">And that kind of change takes consistency.</p>
                    <p className="mb-4">Here’s what happens when you stay the course:</p>
                    <p className="mb-4">
                        ✅ Blood sugar begins to stabilise, even after meals<br />
                        ✅ Sugar cravings quiet down<br />
                        ✅ Insulin sensitivity improves — your cells start listening again<br />
                        ✅ Energy no longer crashes midday<br />
                        ✅ And yes… you get to enjoy your favourite foods without guilt
                    </p>
                </div>
                <div className="col-md-4 mx-3 text-wrap text-break">
                    <p className="fw-bold mb-4">But here’s the part most people never get to experience:</p>
                    <p className="mb-4">
                        The biggest transformations don’t show up in Week 1.<br />
                        <b>They show up after Month 3.</b><br />
                        That’s when the real breakthroughs happen.
                    </p>
                    <p className="mb-4">
                        The moment your body starts to trust <i>itself</i> again.
                        The moment you wake up and feel like you again.
                    </p>
                    <p className="mb-4 fw-bold">The moment you realise… it’s working.</p>
                    <p className="mb-4">
                        <b>And that’s exactly what these extra bottles give you:</b><br />
                        👉 Enough supply to cross that critical milestone<br />
                        👉 Without delays or running out<br />
                        👉 Without losing momentum
                    </p>
                </div>
            </div>
        </div>
    </section >
);

export default ThisMatters;